import React from 'react';
import { Icon } from 'antd';
import icons from '../../icons/icons';

import HeadingBar from '../HeadingBar';
import InstagramSlider from "../InstagramSlider";

const prevArrow = (
  <button className="slick-prev">
    <Icon component={icons.prev} />
  </button>
);

const nextArrow = (
  <button className="slick-next">
    <Icon component={icons.next} />
  </button>
);

const sliderSettings = {
  prevArrow: prevArrow,
  nextArrow: nextArrow,
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  //centerPadding: 0,
  centerMode: false,
  //rows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

const InstagramFeed = ({ posts }) => (
  <React.Fragment>
    <HeadingBar title={`Instagram Feed`} />
    <InstagramSlider
      instagramPosts={posts}
      sliderSettings={sliderSettings}
    />
  </React.Fragment>
)

export default InstagramFeed;


// WEBPACK FOOTER //
// ./src/components/Modules/InstagramFeed/index.js